import React, { Fragment } from 'react';
import TrackOrderState from './track-order-state';
import { OrderType } from 'models/order.model';
import { OrderLogs } from 'utils/constants';
import { ENUM_ORDER_LOG_ACTIONS } from 'utils/enum';

type Props = {
  order: OrderType;
  expand?: boolean;
};
const TrackOrderStatesGroup = ({ order, expand }: Props) => {
  const isRecalled = order?.order_logs?.find((o) => o.action === 'order_recalled');

  return (
    <Fragment>
      <TrackOrderState
        time={order.created_at}
        timeSince={order.kitchen_verified_time}
        start
        text='Order Created'
        innerText='Waiting for kitchen to confirm order'
      />
      {isRecalled ? (
        <div>
          {order?.order_logs?.map((logs, index) => (
            <TrackOrderState
              key={index}
              time={logs.created_at}
              timeSince={order.order_logs[index - 1]?.created_at}
              text={OrderLogs[logs.action as ENUM_ORDER_LOG_ACTIONS]?.name}
              innerText={OrderLogs[logs.action as ENUM_ORDER_LOG_ACTIONS]?.text}
            />
          ))}
          <TrackOrderState
            end
            time={order?.completed_time}
            text={'Order completed'}
            innerText={'Order has been completed'}
          />
        </div>
      ) : !order.cancelled ? (
        <Fragment>
          <TrackOrderState
            time={order.kitchen_start_order}
            timeSince={order.kitchen_dispatched_time}
            start={true}
            text='Order Received'
            innerText='Waiting for kitchen to confirm order'>
            <>
              {expand && (
                <>
                  <TrackOrderState
                    hideMark={true}
                    time={order.kitchen_start_order}
                    timeSince={order.kitchen_verified_time}
                    text='Order Received'
                  />
                  <TrackOrderState
                    hideMark={true}
                    time={order.kitchen_accepted_time}
                    timeSince={order.kitchen_completed_time}
                    text='Order Started'
                  />
                  <TrackOrderState
                    hideMark={true}
                    time={order.kitchen_completed_time}
                    timeSince={order.kitchen_dispatched_time}
                    text='Order Prepared'
                  />
                </>
              )}
            </>
          </TrackOrderState>

          <TrackOrderState
            time={order.kitchen_dispatched_time}
            timeSince={order.completed_time}
            text='Order dispatched'
            innerText='Rider is enroute'
          />
          {!order.pickup && (
            <TrackOrderState
              time={order.rider_arrived_time}
              timeSince={order.kitchen_dispatched_time}
              text='Rider arrived'
              innerText='Rider just arrived'
            />
          )}
          <TrackOrderState
            time={order.completed_time}
            timeSince={null}
            end
            text={order.pickup ? 'Order collected' : 'Order delivered'}
            innerText={
              order.completed_time ? 'User has received meal' : 'User is yet to receive meal'
            }
          />
        </Fragment>
      ) : (
        <TrackOrderState
          time={order.cancelled_time}
          text='Order Cancelled'
          end
          isCancelled
          innerText='Order was canceled'>
          <>
            {expand && (
              <>
                <TrackOrderState
                  hideMark={true}
                  time={order.kitchen_verified_time}
                  timeSince={order.kitchen_verified_time}
                  text='Order Received'
                />
                <TrackOrderState
                  hideMark={true}
                  time={order.kitchen_verified_time}
                  timeSince={order.kitchen_completed_time}
                  text='Order Started'
                />
                <TrackOrderState
                  hideMark={true}
                  time={order.kitchen_completed_time}
                  timeSince={order.kitchen_dispatched_time}
                  text='Order Prepared'
                />
              </>
            )}
          </>
        </TrackOrderState>
      )}
    </Fragment>
  );
};

export default TrackOrderStatesGroup;
